import React, { useState } from 'react'
import GoogleLogin from 'react-google-login'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import { useLocation } from 'react-router-dom'
import { FaGoogle, FaFacebookF } from 'react-icons/fa'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import qs from 'query-string'
import Axios from 'axios'
import cookie from 'react-cookies'
import moment from 'moment'
import { ROUTE_REGISTER_SUCCESS, ROUTE_LOGIN_SUCCESS } from '../constants'
import { get } from 'lodash'
import TagManager from 'react-gtm-module'
import jsonToFormData from '@ajoelp/json-to-formdata'

const Social = (props) => {

  const location = useLocation()
  const [from] = useState(qs.parse(location.search).from)
  const { t } = useTranslation('translation', { useSuspense: false })
  const success = (user) => {
    localStorage.setItem('user', JSON.stringify(user));
    if (user.event === 'login') {
      window.location.href = from ? `${ROUTE_LOGIN_SUCCESS}?from=${encodeURIComponent(from)}` : ROUTE_LOGIN_SUCCESS 
    } else if (user.event === 'signup') {
      window.location.href = from ? `${ROUTE_REGISTER_SUCCESS}?from=${encodeURIComponent(from)}` : ROUTE_REGISTER_SUCCESS 
    }
  }

  const userAlreadyExist = async (email) => {
    try {
      const { data: { data: result } = {} } = await Axios.post(`${process.env.REACT_APP_WEBSITE_PATH}/api/auth/check`, jsonToFormData({
        email: email,
      }, {
        arrayIndexes: true
      }))
      return (!result.error && result.email === email) ? true : false
    } catch (e) {
      return false
    }
  }

  return (
    <div className='flex items-center justify-center w-full pt-4'>
      <GoogleLogin
        clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
        onSuccess={async (response) => {
          if (props.handleOnSuccess && !(await userAlreadyExist(response.profileObj.email))) {
            props.handleOnSuccess({
              name: response.profileObj.givenName,
              surname: response.profileObj.familyName,
              email: response.profileObj.email,
              picture: response.profileObj.imageUrl,
              loginType: 'google',
              googleId: response.googleId,
              from,
            })
          } else {
            TagManager.dataLayer({
              dataLayer: {
                event: 'asyncAction',
                gaHitType: 'event',
                category: 'Login',
                action: 'Login-Submit',
                label: 'google'
              }
            })
            const { data: res } = await Axios.post(`${process.env.REACT_APP_WEBSITE_PATH}/api/auth/login`, {
              name: response.profileObj.givenName,
              surname: response.profileObj.familyName,
              email: response.profileObj.email,
              picture: response.profileObj.imageUrl,
              loginType: 'google',
              googleId: response.googleId,
              googleAccessToken: response.tokenId,
              from
            })
            cookie.save('8egma2jfs9mu', res.data.api_token, {
              expires: moment().add(7, 'days').toDate(),
              path: '/'
            })
            TagManager.dataLayer({
              dataLayer: {
                event: 'asyncAction',
                gaHitType: 'event',
                category: 'Login',
                action: 'Login-Success',
                label: 'google'
              }
            })
            console.log({res})
            success(res.data)
          }
          //window.location.href = `${process.env.REACT_APP_WEBSITE_PATH}/${res.data.redirect}`
          // history.replace('/google/response')
        }}
        onFailure={response => {
          TagManager.dataLayer({
            dataLayer: {
              event: 'asyncAction',
              gaHitType: 'event',
              category: 'Login',
              action: 'Login-Fail',
              label: 'google'
            }
          })
          const errorsToExlude = [
            'popup_closed_by_user',
            'idpiframe_initialization_failed'
          ]
          //console.log(response);
          if (!errorsToExlude.includes(response.error)) {
            toast.error(t('errorSocial'))
          }
        }}
        cookiePolicy={'single_host_origin'}
        render={renderProps => (
          <button onClick={renderProps.onClick} disabled={renderProps.disabled} className='bg-red-500 text-white rounded-full p-3 text-2xl mx-2' ><FaGoogle /></button>
        )}
      />
      <FacebookLogin
        appId={process.env.REACT_APP_FACEBOOK_APP_ID}
        fields="first_name,last_name,email,picture"
        disableMobileRedirect
        callback={async (response) => {
          const userExist = await userAlreadyExist(response.email)
          if (props.handleOnSuccess && !userExist) {
            props.handleOnSuccess({
              name: response.first_name,
              surname: response.last_name,
              email: response.email,
              picture: get(response, 'picture.data.url'),
              loginType: 'facebook',
              facebookId: response.userID,
              from
            })
          } else {
            TagManager.dataLayer({
              dataLayer: {
                event: 'asyncAction',
                gaHitType: 'event',
                category: 'Login',
                action: 'Login-Submit',
                label: 'facebook'
              }
            })
            const { data: res } = await Axios.post(`${process.env.REACT_APP_WEBSITE_PATH}/api/auth/login`, {
              name: response.first_name,
              surname: response.last_name,
              email: response.email,
              picture: get(response, 'picture.data.url'),
              loginType: 'facebook',
              facebookId: response.userID,
              fbAccessToken: response.accessToken,
              from
            })
            cookie.save('8egma2jfs9mu', res.data.api_token, {
              expires: moment().add(7, 'days').toDate(),
              path: '/'
            })
            TagManager.dataLayer({
              dataLayer: {
                event: 'asyncAction',
                gaHitType: 'event',
                category: 'Login',
                action: 'Login-Success',
                label: 'facebook'
              }
            })
            success(res.data)
          }
          // const { data: res } = await Axios.post(`${process.env.REACT_APP_WEBSITE_PATH}/api/auth/facebook`, response)
          // cookie.save('8egma2jfs9mu', res.data.api_token, {
          //   expires: moment().add(7, 'days').toDate(),
          //   path: '/'
          // })
          //window.location.href = `${process.env.REACT_APP_WEBSITE_PATH}/${res.data.redirect}`
          // success(res.data)
        }}
        onFailure={response => {
          TagManager.dataLayer({
            dataLayer: {
              event: 'asyncAction',
              gaHitType: 'event',
              category: 'Login',
              action: 'Login-Fail',
              label: 'facebook'
            }
          })
          const errorsToExlude = [
            // 'popup_closed_by_user',
            // 'idpiframe_initialization_failed'
          ]
          //console.log(response.error);
          if (!errorsToExlude.includes(response.error)) {
            toast.error(t('errorSocial'))
          }
        }}
        render={renderProps => (
          <button onClick={renderProps.onClick} disabled={renderProps.disabled} className='bg-blue-800 text-white rounded-full p-3 text-2xl mx-2' ><FaFacebookF /></button>
        )}
      />
    </div>
  )
}

export default Social